module.exports = "<div class=\"row h-100 schedule\" *ngIf=\"settings\">\n  <app-day class=\"day col\" *ngFor=\"let day of settings.days\" [date]=\"day\" [class.h-100]=\"settings.hours < 11\"></app-day>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/schedule/schedule.component.html
// module id = ./src/app/schedule/schedule.component.html
// module chunks = main